import { render, staticRenderFns } from "./LgFinderPageConsultarAutorizacaoFornecimento.vue?vue&type=template&id=8a0ac7d0"
import script from "./LgFinderPageConsultarAutorizacaoFornecimento.vue?vue&type=script&lang=js"
export * from "./LgFinderPageConsultarAutorizacaoFornecimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports